class SubDomainService {
    async getAll() {
        return await axios
            .get('subdomain')
            .then((response) => {
                if (response?.name !== 'AxiosError') {
                    return response.data.data;
                } else {
                    return [];
                }
            });
    }

    async create(name) {
        return await axios
            .post('subdomain', {name:name.toLowerCase()})
            .then(response => response);
    }

    async delete(id) {
        return await axios
            .delete(`subdomain/${id}`)
            .then((response) => {
                return response;
            });
    }

    async extendExpirationDate(id){
        return await axios
            .patch(`subdomain/${id}/extend-expiration`)
            .then((response) => {
                return response;
            });
    }

    async checkIsAvailable(subdomain){
        return await axios
            .get(`subdomain/is-available`,{params: {subdomain}})
            .then(response => response)
    }
}

export function useSubDomainService() {
    return new SubDomainService();
}
